import React, { useEffect, useState } from "react";
import { ArrowUp } from "@phosphor-icons/react";

/**
 * Floating "Back to top" button, appears above the AI chat FAB
 * once the user has scrolled past 400px.
 */
export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="md-scroll-top-btn"
      aria-label="Scroll to top"
      data-testid="scroll-top-btn"
    >
      <ArrowUp size={18} weight="bold" />
    </button>
  );
}
